<!-- @format -->

<template>
	<!-- <van-field class="disable-text">
		<template #input> -->
	<template v-if="showValue[0]">
		<van-tag v-if="typeof showValue[1] === 'string'" class="disabled-tag">
			{{ showValue[1] }}
		</van-tag>
		<van-tag v-for="(itm, idx) in showValue[1]" v-else :key="idx" class="disabled-tag">
			{{ itm }}
		</van-tag>
	</template>
	<span v-else>{{ showValue[1] }}</span>
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	import { deepClone } from '@/utils';

	interface Props {
		value: string | number | string[];
		params?: { label: string; value: string; children?: Props['params'] }[];
		showTag?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		value: '',
	});

	const getValue = (value: string | number | (string | number)[], params: Props['params']) => {
		if (Array.isArray(value)) {
			if (value.length > 1) {
				const vals = deepClone(value) as typeof value;
				const item = params?.find((it) => it.value === vals!.shift());

				return `${item?.label}/${getValue(vals, item?.children || [])}`;
			} else {
				return params?.find((it) => it.value === value[0])?.label;
			}
		}

		return params?.find((it) => it.value === value)?.label;
	};

	const showValue = computed(() => {
		if (props.params) {
			if (Array.isArray(props.value)) {
				return [true, props.value.map((itm) => getValue(itm, props.params))];
			} else {
				return [true, getValue(props.value, props.params)];
			}
		} else {
			return [props.showTag, props.value];
		}
	});
</script>

<style scoped>
	.disable-text:after {
		border: 0;
	}

	.disabled-tag + .disabled-tag {
		margin-left: 3px;
	}
</style>
